import { render, staticRenderFns } from "./fileDownloader.vue?vue&type=template&id=206d0ede"
import script from "./fileDownloader.vue?vue&type=script&lang=js"
export * from "./fileDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports